var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "otp-input-container d-flex justify-content-center",
      on: { paste: _vm.onPaste }
    },
    _vm._l(_vm.digits, function(digit, index) {
      return _c("input", {
        key: index,
        ref: "otpDigit" + index,
        refInFor: true,
        staticClass: "otp-digit",
        class: { "otp-digit--filled": digit, "otp-digit--error": _vm.hasError },
        attrs: {
          type: "text",
          inputmode: "numeric",
          maxlength: "1",
          disabled: _vm.disabled,
          "data-cy": "otp-digit-" + index
        },
        domProps: { value: digit },
        on: {
          input: function($event) {
            return _vm.onInput($event, index)
          },
          keydown: function($event) {
            return _vm.onKeydown($event, index)
          },
          focus: function($event) {
            return _vm.onFocus(index)
          }
        }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }